import { disableRect, enableRect } from './rect'
import { createSpan, getRectangles } from './span'
import { createRelation } from './relation'
import { enableViewMode } from './view'

export default {
    disableRect,
    enableRect,
    createSpan,
    getRectangles,
    createRelation,
    enableViewMode
}



//////////////////
// WEBPACK FOOTER
// ./src/core/src/UI/index.js
// module id = 74
// module chunks = 1